import { Note, NoteFormValues, UsersListOption } from '../../../interfaces/note';

export const getDefaultValuesForAddNote = (
  customerId?: string,
  usersList?: UsersListOption[],
): NoteFormValues | undefined => {
  if (customerId) {
    return {
      note: '',
      users: usersList?.filter((user) => user.id === +customerId) || [],
    };
  }
  return undefined;
};

export const getDefaultValuesForEditNote = (
  note: Note,
  usersList: UsersListOption[],
): NoteFormValues => {
  return {
    note: note.note,
    users:
      usersList.filter((user) =>
        note.users.some((noteUser) => noteUser.id === user.id),
      ) || [],
  };
};
